import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c91172b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-0" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-body item-body p-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "item-bold mb-1" }, "Paying claims is our core focus"),
  /*#__PURE__*/_createElementVNode("span", null, "Your answers to the questions will have an impact on your insurance cover. Valid claims are paid when questions are answered honestly, accurately and completely.")
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-main-title" }, "Application summary", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-content mb-4" }, " Please review and confirm the following information is complete and correct ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-main-title mb-2" }, "Your quote", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-label ps-0" }, "Insurance product and cover amount", -1))
const _hoisted_9 = {
  key: 0,
  class: "item-content mb-2"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "hr" }, null, -1))
const _hoisted_11 = { class: "item-main-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SummarySection = _resolveComponent("SummarySection")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["row", { 'status-banner-small-screen': _ctx.isSmallScreen }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["col-12 card bg-light-blue", { 'px-0 rounded-0': _ctx.isSmallScreen }])
        }, _hoisted_4, 2)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass({ 'p-4 pt-0': _ctx.isSmallScreen })
      }, [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", null, [
          _hoisted_7,
          _hoisted_8,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.policyInfo.submittedSumInsured, (product) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: product.key
            }, [
              (product.value > 0 && product.policyType == _ctx.policyInfo.policy.policyType)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(product.displayName) + " - $" + _toDisplayString(product.value.toLocaleString()), 1))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]),
        _hoisted_10,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summary, (section, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: ""
          }, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(section.title), 1),
            _createVNode(_component_SummarySection, {
              "sub-sections": section.sections
            }, null, 8, ["sub-sections"])
          ]))
        }), 128))
      ], 2)
    ])
  ], 2))
}